<template>
  <a-config-provider :locale="getLocale()">
  <div>
    <a-layout-content style="padding: 0 20px">
      <a-form layout="inline">
        <a-form-item :label="getLanguage('时间')">
          <a-range-picker v-model:value="formState.date" style="width: 400px" show-time format="YYYY/MM/DD HH:mm:ss"
                          valueFormat="YYYY/MM/DD HH:mm:ss" :disabled-date="disabledDate"
                          @calendarChange="onCalendarChange"/>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search">{{ getLanguage('搜索') }}</a-button>
        </a-form-item>
      </a-form>
      <div class="main">
        <a-table class="operate-log-table" bordered :columns="columns" :data-source="dataSource" :pagination="pagination"
                 :loading="loading" @change="handleTableChange" size="samall">
            <template #bodyCell="{ column, text, record }">
                <template v-if="column.dataIndex === 'userName'">
                  {{ getLogDisplayText(record, 'userName', text, language) }}
                </template>
                <template v-if="column.dataIndex === 'desc'">
                  {{ getLogDisplayText(record, 'desc', text, language) }}
                </template>
                <template v-if="column.dataIndex === 'date'">
                  {{ transformLocalDate(text) }}
                </template>
            </template>

        </a-table>
      </div>
    </a-layout-content>
  </div>
  </a-config-provider>
</template>

<script lang="ts" setup>
import request from "../../common/request";
import { useRouter } from "vue-router";
import { computed, onMounted } from "vue";
import { ref, reactive, toRaw } from "vue";
import type { UploadProps } from "ant-design-vue";
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import zhHK from "ant-design-vue/es/locale/zh_HK";
import { transformBeiJingDate, transformLocalDate } from "../../common/tools";

const router = useRouter();
const loading = ref(false);
const formRef = ref();
import { v4 as uuidv4 } from "uuid";
import { message } from "ant-design-vue";

let factoryId = "";
import { Dayjs } from 'dayjs';
/**操作日志记录 */
import { operateLogs } from "@/common/logs";
import { getLanguage } from "@/common/translate";
import { collectUntranslatedChinesePhrases, getLogDisplayText } from "@/common/log-translate";


let language: any = ref('English')
const getLang = () => {
  language.value = localStorage.getItem('language') || 'English'
}
getLang();

operateLogs('Access operative logging');
/**操作日志记录 */
const formState = ref({
  keyWord: "",
  date: [],
  skip: 1,
  take: 15,
  total: 0,
});
const pagination = computed(() => ({
  total: formState.value.total,
  current: formState.value.skip,
  pageSize: formState.value.take,
}));

const dataSource = ref([]);
const columns = [
  {
    title: getLanguage("操作人") ,
    dataIndex: "userName",
    align: "center"
  },
  {
    title: getLanguage("操作路由"),
    dataIndex: "router",
    align: "center"
  },
  {
    title: getLanguage("操作详情"),
    dataIndex: "desc",
    align: "center"
  },
  {
    title: getLanguage("时间"),
    dataIndex: "date",
    align: "center"
  }
];
const handleTableChange = (pagination: any, filters: any, sorter: any) => {
  console.log(`当前页码：${pagination.current}，每页显示条数：${pagination.pageSize}`);
  // 处理分页数据
  formState.value.skip = pagination.current
  search();
}
// 查询
const search = () => {
  var params = {
    skip: formState.value.skip,
    take: formState.value.take,
  }
  if (formState.value.date && formState.value.date.length) {
    params.begin = transformBeiJingDate(formState.value.date[0])
    params.end = transformBeiJingDate(formState.value.date[1])
  } else {
    delete params.begin
    delete params.end
  }
  const config = {
    params: params,
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/logs/operate", config).then((res: any) => {
    if (res) {
      dataSource.value = res.data.list;
      formState.value.total = res.data.count

      const unresolved = collectUntranslatedChinesePhrases(res.data.list || [], ["userName", "desc"], language.value);
      if (unresolved.length) {
        console.warn("[log-i18n][operate] Untranslated Chinese phrases:", unresolved);
      }
    }
  });
};

// 在组件加载完成后执行一些操作
onMounted(async () => {
  search();
});

const dates = ref<any>();

const disabledDate = (current: Dayjs) => {
  if (!dates.value || (dates.value as any).length === 0) {
    return false;
  }
  const tooLate = dates.value[0] && current.diff(dates.value[0], 'days') > 30;
  const tooEarly = dates.value[1] && current.diff(dates.value[1], 'days') > 30;
  return tooEarly || tooLate;
};

const onCalendarChange = (val: any) => {
  dates.value = val;
};
const getLocale = () => {
  let data = zhCN
  
  if(language.value === 'English') {
    data = enUS
  }
  if(language.value === 'Chinese_ft') {
    data = zhHK
  }
  return data
}

</script>
<style scoped>
.main {
  margin-top: 30px;
}

:deep(.operate-log-table .ant-table-thead > tr > th) {
  color: #fff !important;
}
</style>
